//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";
import ComponentsUtils from "../../mixins/components-utils";
import Events from "../../mixins/events";
import QFabricModal from "../../../q-fabric-modal.vue";

export default {
    name: "QfMProcessConfigure",
    components: { QFabricModal, QAuModelPicker },
    mixins: [ComponentsUtils, Events],
    props: {
        mapping: { type: Object, default: () => {} }
    },
    data() {
        return {
            mappedElements: {
                listOfMappedElements: [],
                mapping: {},
                attachments: []
            },
            placeholderExternal: this.$t("userInterface.properties.pickerPlaceholder"),
            currentElementDataModel: [],
            localShow: true,
            dataModelModel: [],
            defaultData: true,
            modelSelection: []
        };
    },
    computed: {
        actions() {
            return [{ label: this.$t("generic.done"), name: "save", disable: false }];
        }
    },
    beforeMount() {
        if (this.mapping.listOfMappedElements && this.mapping.listOfMappedElements.length) {
            this.mappedElements = this.mapping;
            this.dataModelModel = this.mapping.listOfMappedElements;
        }
    },
    methods: {
        onModelSelect(modelSelect) {
            this.modelSelection = modelSelect;
            this.defaultData = false;
        },
        getDataToSend() {
            const listOfMappedElements = [];
            const mapping = {};
            const attachments = [];

            this.modelSelection.forEach(elem => {
                listOfMappedElements.push(elem.formatted);

                if (!elem.isEmbeded) {
                    const { parents = [] } = elem;
                    if (elem.node.attrType === "attachment") {
                        attachments.push(elem.key);
                    }
                    mapping[elem.key] = elem.formatted;
                    for (let i = 0; i < parents.length; i++) {
                        if (parents[i].node.isList) {
                            mapping[`${parents[i].key}._path_`] = parents[i].formatted;
                        }
                    }
                }
            });

            return { listOfMappedElements, mapping, attachments };
        },
        modalAction(action) {
            if (action.detailed === "save") {
                this.$emit("update", this.defaultData ? this.mappedElements : this.getDataToSend());
            } else {
                this.$emit("update", this.mappedElements);
            }
            this.localShow = false;
        },
        modalAfterHide() {
            this.$emit("input", false);
        }
    }
};
